import { useEffect, useRef, useState } from "react";

export const useElementSize = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const node = ref.current;

        if (!node || typeof window === "undefined") {
            return;
        }

        const handleResize = () => {
            const { width, height } = node.getBoundingClientRect();
            setSize({ width, height });
        };

        handleResize();

        const observer = new window.ResizeObserver(handleResize);
        observer.observe(node);

        return () => observer.disconnect();
    }, [ref]);

    return [ref, size] as const;
};
